import React, { useState } from "react";
import tw from "twin.macro";
import "./NavBar.css";

import HeaderLogo from "../Images/logo.png";

import LogoBlack from "../Images/logoblack.png";

const Container = tw.div`relative  z-50 `;
const TopContainer = tw.div`z-40 sticky top-0 -mb-24 w-full  
border-b border-white
items-center md:w-full   md:flex md:justify-between md:px-64 py-3`;

const PrimaryLink = tw.a` cursor-pointer border-transparent hocus:border-yellow-400 hocus:text-yellow-300 transition duration-300`;

const NavIcon = tw.div` text-3xl absolute right-8 top-7 cursor-pointer md:hidden z-50`;
const NavButtonCollection = tw.div`hidden md:flex`;

const LeftContainer = tw.div``;

const NavButton = tw.div` md:mx-6  md:my-4 ml-10 text-black py-2 `;

const ServicesContainer = tw.div` z-10 py-2  border-b border-l border-r  md:absolute  left-0 top-14 w-40`;
const MultipleContainer = tw.a`block py-2`;

const HeaderLogoContainer = tw.div`md:mr-40 w-64 ml-10 hidden md:block`;
const HeaderLogoContainerMobile = tw.div` md:mr-40 w-64 ml-4  block md:hidden`;
const HeaderLogoContainerMobileOpen = tw.div` md:mr-40 w-64 ml-4 mt-2 pt-1 mb-3`;

const MobileNavContainer = tw.div`fixed top-0 bg-white w-full`;

export default () => {
  let [open, setOpen] = useState(false);
  let [open_services, setOpenServices] = useState(false);

  const [colorChange, setColorchange] = useState(false);
  const changeNavbarColor = () => {
    if (window.scrollY >= 80) {
      setColorchange(true);
    } else {
      setColorchange(false);
    }
  };
  window.addEventListener("scroll", changeNavbarColor);

  const change_services_bar = () => {
    setOpenServices(!open_services);
    console.log("clicked");
  };

  return (
    <>
      <TopContainer className={colorChange ? "colorChange" : "noChange"}>
        <HeaderLogoContainer>
          <a href="/">
            {colorChange ? <img src={LogoBlack} /> : <img src={HeaderLogo} />}
          </a>
        </HeaderLogoContainer>

        {open === false ? (
          <HeaderLogoContainerMobile>
            <a href="/">
              {colorChange ? <img src={LogoBlack} /> : <img src={HeaderLogo} />}
            </a>
          </HeaderLogoContainerMobile>
        ) : null}

        <NavIcon
          className={colorChange ? "colorChange" : "noChange"}
          onClick={() => setOpen(!open)}
        >
          <ion-icon
            name={open ? "close" : "menu"}
            class={open ? "menu-icon-open" : "menu-icon-close"}
          ></ion-icon>
        </NavIcon>

        <LeftContainer>
          <NavButtonCollection>
            <div class="container cyan brackets">
              <PrimaryLink href="/">Home</PrimaryLink>
              <PrimaryLink href="/About">About</PrimaryLink>

              <PrimaryLink href="/Services">Services</PrimaryLink>

              {/* <PrimaryLink onClick={() => change_services_bar()}>
                Services
                {open_services === true ? (
                  <ServicesContainer className={colorChange ? "colorChange" : "noChange"}>
                    <MultipleContainer href="/Insulation">Insulation</MultipleContainer>
                    <MultipleContainer href="/Drywall">Drywall</MultipleContainer>
                    <MultipleContainer href="/MudTape">Mud & Tape</MultipleContainer>
                    <MultipleContainer href="/Paint">Paint</MultipleContainer>
                  </ServicesContainer>
                ) : null}
              </PrimaryLink> */}

              <PrimaryLink href="/Projects">Projects</PrimaryLink>
              <PrimaryLink href="/ContactUs">Contact</PrimaryLink>
            </div>
          </NavButtonCollection>
        </LeftContainer>

        {open === true ? (
          <>
            <MobileNavContainer>
              <HeaderLogoContainerMobileOpen>
                {" "}
                <img src={LogoBlack} />
              </HeaderLogoContainerMobileOpen>
              <NavButton>
                <PrimaryLink href="/">Home</PrimaryLink>
              </NavButton>

              <NavButton>
                <PrimaryLink href="/About">About</PrimaryLink>
              </NavButton>
              <NavButton>
                <PrimaryLink href="/Services">Services</PrimaryLink>
              </NavButton>
              <NavButton>
                <PrimaryLink href="/Projects">Projects</PrimaryLink>
              </NavButton>
              <NavButton>
                <PrimaryLink href="/ContactUs">Contacts</PrimaryLink>
                <br /> <br />
              </NavButton>
            </MobileNavContainer>
          </>
        ) : null}
      </TopContainer>
    </>
  );
};
